import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import TextAreaField from 'components/TextAreaField';
import Dialog from 'components/Dialog';
import * as validators from 'utils/validators';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class MarkOrdersAsPaid extends Dialog {


    render() {
        const { handleSubmit, closeButtonLabel, markAsPaidResults, processing } = this.props;
        const show = this.state.show;
        return (

            <Modal backdrop="static" enforceFocus={true} show={show || false} onHide={this.hide}>
                <form onSubmit={handleSubmit(this.props.onOk)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Capture Payments Manually</Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{ overflowY: 'visible' }}>
                        <p>Enter orders and amount on each line</p>
                        <Field
                            className="form-control"
                            name="ordersCSV"
                            component={TextAreaField}
                            type="text"
                            placeholder="#2456, 40.00&#10;#2457, 64.00"
                            validate={[validators.required]}
                        />

                       
                        { markAsPaidResults && markAsPaidResults.length > 0 &&
                            <div id="markAsPaidResults">
                                <br/>
                                
                                <BootstrapTable search={false} data={markAsPaidResults} hover>
                                    <TableHeaderColumn isKey width='100' dataField='name' dataSort={true}>Order #</TableHeaderColumn>
                                    <TableHeaderColumn with='150' dataField='financial_status'>New Status</TableHeaderColumn>
                                    <TableHeaderColumn width='100' dataField='status' dataSort={true}>Process</TableHeaderColumn>                                    
                                    <TableHeaderColumn width='250' dataField='reason' dataSort={true}>Reason</TableHeaderColumn>
                                </BootstrapTable>
                               <style dangerouslySetInnerHTML={{__html: `
                               #markAsPaidResults > .react-bs-table-container > .react-bs-table-pagination{
                                   position: relative;
                               }

                               #markAsPaidResults > .react-bs-table-container > .react-bs-table > .react-bs-container-header{
                                    position: relative;
                                    top: 0px;
                               }

                               #markAsPaidResults{
                                overflow-y: auto;
                                height: 400px;
                               }
                               `}}>

                               </style>
                            </div>
                        }
                    </Modal.Body>

                    <Modal.Footer>
                    {markAsPaidResults && markAsPaidResults.length > 0 && !processing && <button type="button" className="btn btn-default pull-left" onClick={
                                    ()=>{
                                        let csvFile = "SEP=,\r\nOrder Number, New Financial Status, Status, Reason" + "\r\n";

                                        markAsPaidResults.forEach(function(res) {
                                            let row = `${res.name}, ${res.financial_status || ''}, ${res.status}, ${res.reason}`
                                            csvFile += row + "\r\n";
                                        });

                                        var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
                                        if (navigator.msSaveBlob) { // IE 10+
                                            navigator.msSaveBlob(blob, filename);
                                        } else {
                                            var link = document.createElement("a");
                                            if (link.download !== undefined) { // feature detection
                                                // Browsers that support HTML5 download attribute
                                                var url = URL.createObjectURL(blob);
                                                link.setAttribute("href", url);
                                                link.setAttribute("download", "mark_as_paid_results.csv");
                                                link.style.visibility = 'hidden';
                                                document.body.appendChild(link);
                                                link.click();
                                                document.body.removeChild(link);
                                            }
                                        }
                                    }
                                }>Download results as CSV</button>}                        
                        <Button type="button" onClick={this.hide}>{closeButtonLabel}</Button>
                        <Button type="submit" disabled={processing} bsStyle="success">{processing ? "Processing...": "Begin Capture Payments"}</Button>
                    </Modal.Footer>

                </form>
            </Modal>

        );
    }
}


MarkOrdersAsPaid.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dialogTitle: PropTypes.string.isRequired,
    closeButtonLabel: PropTypes.string.isRequired
}

let MarkOrdersAsPaidForm = reduxForm({ form: "MarkOrdersAsPaid" })(MarkOrdersAsPaid);

const selector = formValueSelector('MarkOrdersAsPaid');

MarkOrdersAsPaid = connect(state => {

    return {
        markAsPaidResults: state.orders.markAsPaidResults,
        processing: state.orders.markAsPaidResultsProcessing
    };

}, null, null, {
    withRef: true
})(MarkOrdersAsPaidForm);

export default MarkOrdersAsPaid;



// WEBPACK FOOTER //
// app/components/dashboard/MarkOrdersAsPaid.jsx